import React from "react";
import {ChipLabel} from "./index";

const JourneyChips = ({entity}) => {
    return (
        <React.Fragment>
            {
                entity.customer_journey_stage === 'Adoption' && <ChipLabel label={"Adoption"} className={"data-access-chip adoption"}/>
            }
            {
                entity.customer_journey_stage === 'Onboarding' && <ChipLabel label={"Onboarding"} className={"data-access-chip onboarding"}/>
            }
            {
                entity.customer_journey_stage === 'Nurture' && <ChipLabel label={"Nurture"} className={"data-access-chip nurture"}/>
            }
            {
                entity.customer_journey_stage === 'Advocate' && <ChipLabel label={"Advocate"} className={"data-access-chip advocate"}/>
            }
            {
                (!entity.customer_journey_stage || entity.customer_journey_stage === 'None') && <ChipLabel label={"None"} className={"data-access-chip none"}/>
            }
        </React.Fragment>
    )
}

export default JourneyChips;